import { useMemo } from 'react';
import getUrlByClientId from '@noku-tech/nokulibrary-common/dist/functions/utils/getUrlByClientId';

const useRedirectURL = () => {
    const searchParams = useMemo(() => new URLSearchParams(window.location.search?.split("?")?.[1] ?? ""), []);
    const redirectUri = useMemo(() => searchParams.get("redirect_uri") ?? "", [searchParams]);
    const clientId = useMemo(() => searchParams.get("client_id") ?? "", [searchParams]);
    const redirectHost = useMemo(() => {
        try {
            searchParams.get("client_id");
            return getUrlByClientId(clientId);
        }
        catch (e) { }
        return null;
    }, [clientId, searchParams]);
    const redirectUrl = useMemo(() => {
        if (!redirectHost)
            return null;
        if (redirectUri && redirectUri.startsWith("/")) {
            return `${redirectHost}${redirectUri}`;
        }
        return `${redirectHost}/${redirectUri}`;
    }, [redirectHost, redirectUri]);
    return {
        redirectUri,
        clientId,
        redirectHost,
        redirectUrl,
    };
};

export { useRedirectURL as default };
